import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import Root from './Root';
import * as serviceWorker from './serviceWorker';

import "assets/scss/material-dashboard-pro-react.scss?v=1.5.0";
import "assets/css/ui-fix.scss";
import "assets/css/fonts/nanumgothic.scss";
import "assets/css/neo4jd3.css";
import "assets/css/font-awesome.min.css";

var agent = navigator.userAgent.toLowerCase(); 
if( agent.indexOf("trident/") > -1) {
    import("assets/css/ui-fix-ie.scss");
}
if(agent.indexOf( "edge/" ) > -1 ) {
    import("assets/css/ui-fix-edge.scss");
}

ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
